angular.module('internal.notifications', [])
    .config(['$stateProvider',
        /**
         * @param {ui.IStateProvider} $stateProvider
         */
        function ($stateProvider) {
            $stateProvider.state('internal.notifications', {
                url: '/notifications',
                params: {
                    id: null
                },
                views: {
                    content: {
                        controllerAs: 'vm',
                        controller: 'NotificationsController',
                        templateUrl: 'js/internal/notifications/notifications/notifications.html',
                    }
                }
            });
            $stateProvider.state('internal.notifications_settings', {
                url: '/notifications/settings',
                views: {
                    content: {
                        controllerAs: 'vm',
                        templateUrl: 'js/internal/notifications/settings/notifications.settings.html',
                        controller: 'NotificationsSettingsCtrl'
                    }
                }
            });
        }]);